import React, {Component} from 'react';
import PropTypes from 'prop-types';
import history from '../history';

export default class LocationListener extends Component{

    static propTypes = {
        onChange: PropTypes.func,
        block: PropTypes.func
    };

    _unlisten;
    _unblock;

    componentDidMount(){

        if(this.props.onChange)
            this._unlisten = history.listen((location) => {
                this.props.onChange(location);
            });

        if(this.props.block)
            this._unblock = history.block(this.props.block);
    }

    unblock(){
        if(this._unblock)
            this._unblock();
    }

    unlisten(){
        if(this._unlisten)
            this._unlisten();
    }

    componentWillUnmount(){
        this.unlisten();
        this.unblock();
    }

    render() {
        return this.props.children ||  null;
    }
}


// WEBPACK FOOTER //
// ./src/common/LocationListener.js